// Non-React Components
import CSRFToken from "../components/csr_token";
import Navigation from "../components/navigation_toggle";

export default function() {
  CSRFToken();
  Navigation();
}
